/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { FilterLogic } from '../filterLogic.schema';
import { IFilterBase } from '../iFilterBase.schema';

export const GetAllIncidentFileFieldTypesParams = zod.object({
  "payload.Logic": zod.lazy(() => FilterLogic).optional(),
  "payload.Filters": zod.array(zod.lazy(() => IFilterBase)).optional()
})

export type GetAllIncidentFileFieldTypesParams = zod.input<typeof GetAllIncidentFileFieldTypesParams>;
export type GetAllIncidentFileFieldTypesParamsOutput = zod.output<typeof GetAllIncidentFileFieldTypesParams>;
